let toastContainer = null

// 创建Toast容器
function createToastContainer() {
  if (toastContainer) return toastContainer

  toastContainer = document.createElement('div')
  toastContainer.id = 'toast-container'
  toastContainer.style.cssText = `
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9999;
    pointer-events: none;
  `
  document.body.appendChild(toastContainer)
  return toastContainer
}

// Toast类
class Toast {
  constructor(options) {
    this.id = Date.now() + Math.random()
    this.options = {
      message: '',
      type: 'info',
      title: '',
      duration: 3000,
      persistent: false,
      ...options
    }
  }

  show() {
    const container = createToastContainer()

    // 创建Toast元素
    const toastElement = document.createElement('div')
    toastElement.id = `toast-${this.id}`
    toastElement.style.cssText = `
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      min-width: 300px;
      max-width: 500px;
      margin-bottom: 12px;
      pointer-events: auto;
      border-left: 4px solid ${this.getColorByType()};
      animation: slideInRight 0.3s ease-out;
    `

    // 创建图标
    const icon = document.createElement('div')
    icon.style.cssText = `
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-weight: bold;
      font-size: 14px;
      color: white;
      background: ${this.getColorByType()};
    `
    icon.textContent = this.getIconByType()

    // 创建内容区域
    const content = document.createElement('div')
    content.style.cssText = 'flex: 1; min-width: 0;'

    if (this.options.title) {
      const title = document.createElement('div')
      title.style.cssText = `
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin-bottom: 4px;
      `
      title.textContent = this.options.title
      content.appendChild(title)
    }

    const message = document.createElement('div')
    message.style.cssText = `
      font-size: 14px;
      color: #595959;
      line-height: 1.4;
      word-wrap: break-word;
    `
    message.textContent = this.options.message
    content.appendChild(message)

    // 创建关闭按钮
    const closeBtn = document.createElement('button')
    closeBtn.style.cssText = `
      flex-shrink: 0;
      background: none;
      border: none;
      font-size: 18px;
      color: #8c8c8c;
      cursor: pointer;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: all 0.2s;
    `
    closeBtn.textContent = '×'
    closeBtn.onmouseover = () => {
      closeBtn.style.background = '#f5f5f5'
      closeBtn.style.color = '#595959'
    }
    closeBtn.onmouseout = () => {
      closeBtn.style.background = 'none'
      closeBtn.style.color = '#8c8c8c'
    }
    closeBtn.onclick = () => this.close()

    // 组装Toast
    toastElement.appendChild(icon)
    toastElement.appendChild(content)
    toastElement.appendChild(closeBtn)

    // 添加到容器
    container.appendChild(toastElement)

    // 自动关闭
    if (!this.options.persistent) {
      setTimeout(() => {
        this.close()
      }, this.options.duration)
    }

    return this
  }

  close() {
    const toastElement = document.getElementById(`toast-${this.id}`)
    if (toastElement) {
      toastElement.style.animation = 'slideOutRight 0.3s ease-in'
      setTimeout(() => {
        if (toastElement.parentNode) {
          toastElement.parentNode.removeChild(toastElement)
        }
      }, 300)
    }
  }

  getColorByType() {
    const colors = {
      success: '#52c41a',
      error: '#ff4d4f',
      warning: '#faad14',
      info: '#1890ff'
    }
    return colors[this.options.type] || colors.info
  }

  getIconByType() {
    const icons = {
      success: '✓',
      error: '✕',
      warning: '!',
      info: 'i'
    }
    return icons[this.options.type] || icons.info
  }
}

// 添加CSS动画
function addToastStyles() {
  if (document.getElementById('toast-styles')) return

  const style = document.createElement('style')
  style.id = 'toast-styles'
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `
  document.head.appendChild(style)
}

// 初始化样式
addToastStyles()

// Toast方法
const toast = {
  success(message, options = {}) {
    return new Toast({ message, type: 'success', ...options }).show()
  },

  error(message, options = {}) {
    return new Toast({ message, type: 'error', persistent: true, ...options }).show()
  },

  warning(message, options = {}) {
    return new Toast({ message, type: 'warning', ...options }).show()
  },

  info(message, options = {}) {
    return new Toast({ message, type: 'info', ...options }).show()
  },

  // 通用方法
  show(options) {
    return new Toast(options).show()
  }
}

export default toast